import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/ranking", label: "人气排行榜" },
  { to: "/category", label: "热门分类" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.04)]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-3-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">
            漫糖<span className="text-primary-500">韩漫</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                  active
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/ranking"
            className="flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
          >
            <i className="ri-fire-fill"></i>
            今日热榜
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`block rounded-lg px-3 py-2.5 text-sm ${
                location.pathname === l.to
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}